var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyStateBall = function SvgEmptyStateBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.623 10.0306C11.2345 -0.65781 26.8767 -0.9152 32.3502 11.5953C35.1178 17.921 34.5868 26.9143 33.9921 35.9284C25.4862 25.9334 16.3996 15.6347 14.623 10.0306Z",
    fill: "url(#paint0_linear_6492_6462)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4325 64.777C64.3391 59.8523 76.1056 35.7138 65.5459 20.353C60.6209 13.1889 52.9079 14.5189 36.4325 15.5056C19.9572 16.4922 3.58279 19.2593 3.58252 40.793C3.58225 62.3266 23.61 67.0398 36.4325 64.777Z",
    fill: "url(#paint1_radial_6492_6462)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4325 64.777C64.3391 59.8523 76.1056 35.7138 65.5459 20.353C60.6209 13.1889 52.9079 14.5189 36.4325 15.5056C19.9572 16.4922 3.58279 19.2593 3.58252 40.793C3.58225 62.3266 23.61 67.0398 36.4325 64.777Z",
    fill: "url(#paint2_linear_6492_6462)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6611 39.489C11.6606 25.0856 16.1121 11.6504 18.3519 5.28968C19.2735 2.67248 22.7224 1.92733 25.0218 3.48039C28.9371 5.84125 36.8248 11.5767 44.787 17.0751C53.0609 22.7888 64.9921 29.1056 59.5163 47.8372C55.3675 62.0296 35.1238 61.3874 35.1238 61.3874C35.1238 61.3874 11.6619 60.997 11.6611 39.489Z",
    fill: "url(#paint3_linear_6492_6462)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9377 60.7307C68.4081 50.6943 72.3906 29.7147 64.6999 16.6804C57.0092 3.64604 46.0524 0.610801 36.9359 1.03814C27.8194 1.46548 9.3022 7.16579 8.5201 27.6291C7.73799 48.0924 18.3806 56.772 29.5122 66.5516C33.8134 70.3304 45.4674 70.767 56.9377 60.7307Z",
    fill: "url(#paint4_linear_6492_6462)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.404889 38.2306C-1.72199 23.4544 4.5444 7.52472 18.8755 7.52472C30.1896 7.52472 36.583 16.1743 45.2749 21.8558C55.9492 28.8332 64.1317 33.645 64.1317 40.7126C64.1317 53.5351 45.0142 60.3451 26.7796 53.0456C13.4749 47.7197 2.53176 53.0068 0.404889 38.2306Z",
    fill: "url(#paint5_radial_6492_6462)",
    fillOpacity: 0.8
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.404889 38.2306C-1.72199 23.4544 4.5444 7.52472 18.8755 7.52472C30.1896 7.52472 36.583 16.1743 45.2749 21.8558C55.9492 28.8332 64.1317 33.645 64.1317 40.7126C64.1317 53.5351 45.0142 60.3451 26.7796 53.0456C13.4749 47.7197 2.53176 53.0068 0.404889 38.2306Z",
    fill: "url(#paint6_linear_6492_6462)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0847 59.9537C30.7772 72.8584 42.6396 68.8155 40.8135 58.6497C39.9449 53.814 32.7058 44.9958 24.9887 35.9277C24.4073 44.7408 23.7649 53.574 26.0847 59.9537Z",
    fill: "url(#paint7_radial_6492_6462)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0847 59.9537C30.7772 72.8584 42.6396 68.8155 40.8135 58.6497C39.9449 53.814 32.7058 44.9958 24.9887 35.9277C24.4073 44.7408 23.7649 53.574 26.0847 59.9537Z",
    fill: "url(#paint8_linear_6492_6462)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_6492_6462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5047 33.3993C41.5047 39.5261 36.5379 44.4929 30.411 44.4929C24.2842 44.4929 19.3174 39.5261 19.3174 33.3993C19.3174 31.0435 20.0517 28.8592 21.3039 27.0628C22.5705 25.2458 23.43 25.0098 21.9824 23.3333C20.1019 21.1555 18.4488 18.4545 27.6648 16.9989C36.2616 15.6403 40.5856 15.1312 38.2674 23.0642C37.7381 24.8755 38.3231 25.3985 39.4247 26.9307C40.7337 28.7517 41.5047 30.9854 41.5047 33.3993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_6492_6462",
    x: 3.31738,
    y: 0.204102,
    width: 58.1875,
    height: 64.2888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6492_6462"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6492_6462",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect2_foregroundBlur_6492_6462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6492_6462",
    x1: 14.1475,
    y1: 9.50955,
    x2: 33.0401,
    y2: 6.3812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E375A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6492_6462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4846 22.2836) rotate(69.3339) scale(31.7632 38.2586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B850C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6492_6462",
    x1: 38.5808,
    y1: 14.6703,
    x2: 38.2857,
    y2: 24.5564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B850C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCADE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6492_6462",
    x1: 16.6144,
    y1: 46.2671,
    x2: 41.1198,
    y2: 36.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342892",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6492_6462",
    x1: 68.5402,
    y1: 31.6686,
    x2: 38.5794,
    y2: 45.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BAEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BAEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6492_6462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0335 15.1131) rotate(84.3771) scale(29.0783 32.4771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65ECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BECE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6492_6462",
    x1: 52.1512,
    y1: 48.165,
    x2: 60.7093,
    y2: 31.7866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342892",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#342892"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6492_6462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.947 65.0377) rotate(-68.2079) scale(18.2613 23.4454)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E375A0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6492_6462",
    x1: 26.1221,
    y1: 39.7502,
    x2: 27.4256,
    y2: 48.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
export { SvgEmptyStateBall as ReactComponent };
export default __webpack_public_path__ + "empty-state-ball.svg";